export const API_ERROR = "api_failed";

export const REPORTS_MENU = "reports_menu";
export const REPORTS_MENU_SUCCESS = "reports_menu_Successful";

export const REPORT_TYPE_CHECK = "report_type_check";
export const SET_PARAMS = "reports_set_params";

export const REPORT_INPUT_CHANGE_VALUE = "report_input_change_value";
export const REPORT_SELECT_CHANGEVALUE = "report_select_change_value";

//MR Reports
export const MR_REPORTS_LIST = "reports_mr_list";
export const MR_REPORTS_LIST_SUCCESS = "reports_mr_list_Successful";
export const SR_REPORTS_LIST = "reports_sr_list";
export const SR_REPORTS_LIST_SUCCESS = "reports_sr_list_Successful";
export const MR_DOC_REPORT = "reports_mr_Doc";
export const MR_DOC_REPORT_SUCCESS = "reports_mr_Doc_Successful";
export const SR_DOC_REPORT = "reports_sr_Doc";
export const SR_DOC_REPORT_SUCCESS = "reports_sr_Doc_Successful";
//PI Reports
export const PI_REPORTS_LIST = "reports_pi_list";
export const PI_REPORTS_LIST_SUCCESS = "reports_pi_list_Successful";
export const PI_DOC_REPORT = "reports_pi_Doc";
export const PI_DOC_REPORT_SUCCESS = "reports_pi_Doc_Successful";

// SI Reports
export const SI_REPORTS_LIST = "reports_Si_list";
export const SI_REPORTS_LIST_SUCCESS = "reports_Si_list_Successful";
export const SI_DOC_REPORT = "reports_Si_Doc";
export const SI_DOC_REPORT_SUCCESS = "reports_Si_Doc_Successful";
//RFQ Reports
export const RFQ_REPORTS_LIST = "reports_rfq_list";
export const RFQ_REPORTS_LIST_SUCCESS = "reports_rfq_list_Successful";
export const RFQ_DOC_REPORT = "reports_rfq_Doc";
export const RFQ_DOC_REPORT_SUCCESS = "reports_rfq_Doc_Successful";
export const RFQ_DOC_PDF = "reports_rfq_doc_pdf";

export const SR_RFQ_REPORTS_LIST = "reports_sr_rfq_list";
export const SR_RFQ_REPORTS_LIST_SUCCESS = "reports_sr_rfq_list_Successful";
export const SR_RFQ_DOC_REPORT = "reports_sr_rfq_Doc";
export const SR_RFQ_DOC_REPORT_SUCCESS = "reports_sr_rfq_Doc_Successful";
export const SR_RFQ_DOC_PDF = "reports_sr_rfq_doc_pdf";

//Quotation Reports
export const Q_REPORTS_LIST = "reports_q_list";
export const Q_REPORTS_LIST_SUCCESS = "reports_q_list_Successful";
export const SRQ_REPORTS_LIST = "reports_SRq_list";
export const SRQ_REPORTS_LIST_SUCCESS = "reports_SRq_list_Successful";
export const Q_DOC_REPORT = "reports_q_Doc";
export const Q_DOC_REPORT_SUCCESS = "reports_q_Doc_Successful";
export const SR_Q_DOC_REPORT = "SR_reports_q_Doc";
export const SR_Q_DOC_REPORT_SUCCESS = "SR_reports_q_Doc_Successful";
export const Q_DOC_PDF = "report_q_doc_pdf";
export const SR_Q_DOC_PDF = "SR_report_q_doc_pdf";

// Unit Report
export const UNIT_REPORTS_LIST = "reports_unit_list";
export const UNIT_REPORTS_LIST_SUCCESS = "reports_unit_list_Successful";
export const UNIT_DOC_REPORT = "reports_unit_Doc";
export const UNIT_DOC_REPORT_SUCCESS = "reports_unit_Doc_Successful";
export const UNIT_DOC_PDF = "report_unit_doc_pdf";

//CQ Reports
export const CQ_REPORTS_LIST = "reports_cq_list";
export const CQ_REPORTS_LIST_SUCCESS = "reports_cq_list_Successful";
export const CQ_DOC_REPORT = "reports_cq_Doc";
export const CQ_DOC_REPORT_SUCCESS = "reports_cq_Doc_Successful";
//SRCQ Reports
export const SR_CQ_REPORTS_LIST = "reports_SR_cq_list";
export const SR_CQ_REPORTS_LIST_SUCCESS = "reports_SR_cq_list_Successful";
export const SR_CQ_DOC_REPORT = "reports_SR_cq_Doc";
export const SR_CQ_DOC_REPORT_SUCCESS = "reports_SR_cq_Doc_Successful";
//PO Reports
export const PO_REPORTS_LIST = "reports_po_list";
export const PO_REPORTS_LIST_SUCCESS = "reports_po_list_Successful";
export const PO_REPORTS_LIST_FOR_DOCUMENT = "reports_po_list_for_document";
export const PO_REPORTS_LIST__FOR_DOCUMENT_SUCCESS =
  "reports_po_list_for_document_Successful";
export const PO_ITEM_REPORTS_LIST = "reports_po_item_list";
export const PO_ITEM_REPORTS_LIST_SUCCESS = "reports_po_item_list_Successful";
export const REPORT_STATUS = "reports_status";
export const DELAY_REPORTS_LIST = "reports_delay_list";
export const REPORT_DOWNLOAD = "reports_download";
export const REPORT_DOWNLOAD_SUCCESS = "reports_download_Successful";

export const WO_REPORTS_LIST = "reports_Wo_list";
export const WO_REPORTS_LIST_SUCCESS = "reports_Wo_list_Successful";
export const WO_ITEM_REPORTS_LIST = "reports_Wo_item_list";
export const WO_ITEM_REPORTS_LIST_SUCCESS = "reports_Wo_item_list_Successful";

export const PO_DOC_REPORT = "reports_po_Doc";
export const WO_DOC_REPORT = "reports_wo_Doc";
export const WO_DOC_REPORT_SUCCESS = "reports_wo_Doc_Successful";
export const PO_DOC_REPORT_SUCCESS = "reports_po_Doc_Successful";
export const PO_DOC_PDF = "report_po_doc_pdf";
export const WO_DOC_PDF = "report_wo_doc_pdf";

//PO Item History Reports
export const PO_AMENDAMENT_REPORTS_LIST = "PO_AMENDAMENT_REPORTS_LIST";
export const PO_AMENDAMENT_REPORTS_LIST_SUCCESS =
  "PO_AMENDAMENT_REPORTS_LIST_SUCCESS";
export const PO_AMENDAMENT_DOC_REPORT = "PO_AMENDAMENT_DOC_REPORT";
export const PO_AMENDAMENT_REPORT_SUCCESS = "PO_AMENDAMENT_DOC_REPORT_SUCCESS";
export const PO_AMENDAMENT_DOC_PDF = "PO_AMENDAMENT_DOC_PDF";

//CQ Reports
export const IGP_REPORTS_LIST = "reports_igp_list";
export const IGP_REPORTS_LIST_SUCCESS = "reports_IGP_list_Successful";
export const IGP_REPORTS_PO_LIST = "reports_igp_po_list";
export const IGP_REPORTS_PO_LIST_SUCCESS = "reports_IGP_po_list_Successful";
export const IGP_DOC_REPORT = "reports_IGP_Doc";
export const IGP_DOC_REPORT_SUCCESS = "reports_IGP_Doc_Successful";

//MR Items Reports
export const MR_ITEMS_REPORTS_LIST = "reports_mr_items_list";
export const MR_ITEMS_REPORTS_LIST_SUCCESS = "reports_mr_items_list_Successful";

// Vendor List Reports
export const VENDOR_REPORTS_LIST = "reports_vendor_list";
export const VENDOR_REPORTS_LIST_SUCCESS = "reports_vendor_list_Successful";

// Rfq Pending Items Reports
export const RFQ_PENDING_REPORTS_LIST = "reports_rfq_pending_list";
export const RFQ_PENDING_REPORTS_LIST_SUCCESS =
  "reports_rfq_pending_list_successful";
  export const RFQ_TO_PO_PENDING_REPORTS_LIST="reports_rfq_to_po_pending_list"
  export const RFQ_TO_PO_PENDING_REPORTS_LIST_SUCCESS="reports_rfq_to_po_pending_list_success"


// Item Wise Reports
export const ITEM_WISE_REPORTS_LIST = "reports_item_wise_list";
export const ITEM_WISE_REPORTS_LIST_SUCCESS =
  "reports_item_wise_list_successful";
export const PENDING_PO_DOC_REPORT = "reports_pending_po_Doc";
export const PENDING_PO_DOC_REPORT_SUCCESS =
  "reports_pending_po_Doc_Successful";
export const CONSUMPTION_DETAILED_DOC_REPORT =
  "reports_consumption_detailed_Doc";
export const CONSUMPTION_DETAILED_DOC_REPORT_SUCCESS =
  "reports_consumption_detailed_Doc_Successful";
export const VENDOR_DUE_DETAILED_DOC_REPORT = "reports_vendor_due_detailed_Doc";
export const VENDOR_DUE_DETAILED_DOC_REPORT_SUCCESS =
  "reports_vendor_due_detailed_Doc_Successful";

//MRTimeline report

export const MRTimelLine_REPORTS_LIST = "reports_MRTimeLine_list";
export const MRTimeLine_REPORTS_LIST_SUCCESS =
  "reports_MRTimeLine_list_Successful";
export const MRTimeLine_DOC_REPORT = "reports_MRTimeLine_Doc";
export const MRTimeLine_DOC_REPORT_SUCCESS =
  "reports_MRTimeLine_Doc_Successful";

  //SRTimeline report

export const SRTimelLine_REPORTS_LIST = "reports_SRTimeLine_list";
export const SRTimeLine_REPORTS_LIST_SUCCESS =
  "reports_SRTimeLine_list_Successful";
export const SRTimeLine_DOC_REPORT = "reports_SRTimeLine_Doc";
export const SRTimeLine_DOC_REPORT_SUCCESS =
  "reports_SRTimeLine_Doc_Successful";

  export const RFQToPOPendingReport_DOC_REPORT="RFQToPOPendingReport_DOC_REPORT";
  export const RFQToPOPendingReport_DOC_REPORT_SUCCESS="RFQToPOPendingReport_DOC_REPORT_SUCCESS";
  export const RFQToPOPendingReport_DOC_PDF="RFQToPOPendingReport_DOC_PDF";

  // RFQ Vendors Report
export const GET_RFQ_VENDORS = "reports_get_rfq_vendors";
export const GET_RFQ_VENDORS_SUCCESS = "reports_get_rfq_vendors_success";

// SR Timeline CSV Export
export const SR_TIMELINE_CSV_EXPORT = "reports_sr_timeline_csv_export";
export const SR_TIMELINE_CSV_EXPORT_SUCCESS = "reports_sr_timeline_csv_export_success";


// MR Timeline CSV Export
export const MR_TIMELINE_CSV_EXPORT = "reports_mr_timeline_csv_export";
export const MR_TIMELINE_CSV_EXPORT_SUCCESS = "reports_mr_timeline_csv_export_success";

// Product Stock Report
export const PRODUCT_STOCK_REPORT_LIST = "reports_product_stock_list";
export const PRODUCT_STOCK_REPORT_LIST_SUCCESS = "reports_product_stock_list_successful";
export const PRODUCT_STOCK_EXPORT_LIST = "reports_product_stock_export_list";
export const PRODUCT_STOCK_EXPORT_LIST_SUCCESS = "reports_product_stock_export_list_successful";